// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5842a883","703":"79510d9e","787":"07f3691d"}[chunkId] + ".chunk.js";
};